import { useNavigate } from "react-router-dom";
import { ReactComponent as CardFampe } from "../../../assets/images/FAMPE.svg";
import "./index.scss";
import {eventTag} from "../../../services/utils";

const eventFampeGA = {
	name: "guarantees",
	category: "guarantees",
	action: "click",
}

const FampeAccess = () => {
	const navigate = useNavigate();

	return (
		<div
			className="comparison-lab-container animate__animated animate__fadeIn animate__delay-1s"
		>
			<CardFampe onClick={() => {
				navigate("/garantias")
				eventTag(eventFampeGA?.name, eventFampeGA?.category, eventFampeGA?.action, "Banner FAMPE")
			}} />
		</div>
	)
}

export default FampeAccess;
